import React, { useRef, useState, useEffect } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  TextInput,
  ScrollView,
  FlatList,
  Platform,
  Dimensions,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import InputFree from "../../component/inputfree";
import Calendar from "react-calendar";
import moment from "moment";
import Modal from "modal-react-native-web";
import RNPickerSelect from "react-native-picker-select";
import { pickImage, pickImageIn } from "../../action/authImage";
import { AntDesign, FontAwesome5 } from "@expo/vector-icons";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { apiservice } from "../../service/service";
import { useIsFocused } from "@react-navigation/native";

const { width, height } = Dimensions.get("window");
export default function editevent({ navigation, route }) {
  const [modalresult, setModalresult] = useState(false);
  const token = useRecoilValue(tokenState);
  const [locate, setLo] = useState({});
  const [dateState, setDateState] = useState(new Date());

  const changeDate = (e) => {
    setDateState(e);
  };

  const [locate1, setLo1] = useState({});
  const [handelCalendar, setHandelCalendar] = useState(false);
  const [handelCalendar1, setHandelCalendar1] = useState(false);
  const [dateState1, setDateState1] = useState(new Date());

  const changeDate1 = (e) => {
    setDateState1(e);
  };

  const placeholder = {
    label: "สถานะ",
    value: null,
    color: "#777777",
  };

  const items = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "NotActive" },
  ]

  const placeholder2 = {
    label: "ของรางวัล",
    value: null,
    color: "#777777",
  };
  const items2 = [
    { label: "โกลด์", value: "โกลด์" },
    { label: "ไดมอนด์", value: "ไดมอนด์" },
    { label: "ไอเทม", value: "ไอเทม " },
  ]

  const [dataReward, setDataReward] = useState([
    { coin: "" },
    { diamond: "" },
    {
      shirt: {},
    },
  ]);
  const focused = useIsFocused();
  const [body, setbody] = useState({
    titel: "",
    Type: "Event",
    distances: [],
    discription: "",
    price: "",
    img_title: null,
    status: "",
    startDate: moment(),
    expireDate: moment(),
    reward: [],
    img_List: [],
    img_Map: null,
    img_bibPremium: null,
    img_bibbasic: null,
    Achievement: null,
    is_end_expired: false,
    is_strava_enable: true,
    is_location_locked: false,
    is_gyroscope_enabled: false,
    lock_location_lat: null,
    lock_location_lng: null,
    lock_location_radius: null,
    tag: [],
  });

  // --- Map selector modal state ---
  const [showMapModal, setShowMapModal] = useState(false);

  const formatCoord = (v, digits = 6) => {
    if (v === null || v === undefined || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(digits) : null;
  };

  const formatRadius = (r) => {
    if (r === null || r === undefined || r === '') return null;
    const n = Number(r);
    return Number.isFinite(n) ? n : null;
  };

  const openMapSelector = () => {
    setbody({
      ...body,
      lock_location_lat: body.lock_location_lat ?? body.lock_location_lat,
      lock_location_lng: body.lock_location_lng ?? body.lock_location_lng,
      lock_location_radius: body.lock_location_radius ?? body.lock_location_radius,
    });
    setShowMapModal(true);
  };

  // keep a ref to modal open state so the persistent listener can check it
  const showMapModalRef = useRef(showMapModal);
  useEffect(() => {
    showMapModalRef.current = showMapModal;
  }, [showMapModal]);

  // add a persistent message listener on mount so it's present before iframe posts
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const listener = (ev) => {
      console.log('persistent iframe message event received:', ev);
      console.log('persistent iframe message origin:', ev.origin);
      console.log('persistent iframe message raw data:', ev.data);
      try {
        let data = ev.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (e) {
            console.log('iframe message: data is string but not JSON:', data);
          }
        }
        if (!showMapModalRef.current) {
          console.log('iframe message received but modal not open; ignoring');
          return;
        }
        if (data && (data.lat != null || data.lng != null)) {
          const lat = data.lat != null ? Number(data.lat) : null;
          const lng = data.lng != null ? Number(data.lng) : null;
          const radius = data.radius != null ? Number(data.radius) : undefined;
          if (Number.isFinite(lat) && Number.isFinite(lng)) {
            setbody((t) => ({ ...t, lock_location_lat: lat, lock_location_lng: lng, lock_location_radius: radius ?? t.lock_location_radius }));
            setShowMapModal(false)
          } else {
            console.log('iframe message: lat/lng not finite after Number():', lat, lng);
          }
        } else {
          console.log('iframe message: payload missing lat/lng:', data);
        }
      } catch (err) {
        console.log('iframe message handler error', err);
      }
    };

    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
  }, []);

  // generate a small HTML page for native WebView (Mapbox GL JS + turf via CDN)
  const mapboxToken = process.env.MAPBOX_TOKEN || "pk.eyJ1Ijoid29uZ3NhdG9ybiIsImEiOiJja2tkMDMxZnowNTAxMm9vZ21vbnE0YWNmIn0.2IjOp_X5pabJXKDN2Mw6sA";
  const makeWebviewHTML = (lat = "13.736717", lng = "100.523186", radius = 100) => {
    return `<!doctype html>
    <html>
    <head>
      <meta name="viewport" content="initial-scale=1,maximum-scale=1,user-scalable=no" />
      <style>html,body,#map{height:100%;margin:0;padding:0;} .controls{position:absolute;z-index:2;right:10px;top:10px;background:#fff;padding:8px;border-radius:6px;font-family:Arial}</style>
      <link href='https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css' rel='stylesheet' />
    </head>
    <body>
    <div id="map"></div>
    <div class="controls">
      <div>Radius (m): <input id="radiusInput" type="number" value="${radius}" style="width:100px"/></div>
      <button id='done' style="margin-top:6px; background:#fcc81d; height: 36px; width: 100px; align-items: center; display: flex; justify-content: center; border: none; border-radius: 6px;">
        <div>Done</div>
      </button>
    </div>
    <script src='https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js'></script>
    <script src='https://cdn.jsdelivr.net/npm/@turf/turf@6/turf.min.js'></script>
    <script>
      mapboxgl.accessToken = '${mapboxToken}';
      const map = new mapboxgl.Map({ container: 'map', style: 'mapbox://styles/mapbox/streets-v11', center: [${lng}, ${lat}], zoom: 13 });
      let marker = new mapboxgl.Marker({draggable:true}).setLngLat([${lng}, ${lat}]).addTo(map);
      let circleId = 'circle-layer';
      function drawCircle(center, radius){
        const options = { steps: 64, units: 'meters' };
        const circle = turf.circle([center.lng, center.lat], radius, options);
        if(map.getSource('circle')){
          map.getSource('circle').setData(circle);
        } else {
          map.addSource('circle', { type: 'geojson', data: circle });
          map.addLayer({ id: circleId, type: 'fill', source: 'circle', paint: { 'fill-color': '#00bcd4', 'fill-opacity': 0.2 } });
        }
      }
      map.on('load', () => {
        drawCircle({lng: ${lng}, lat: ${lat}}, ${radius});
      });
      map.on('click', (e) => {
        const lngLat = e.lngLat.wrap();
        marker.setLngLat(lngLat);
        drawCircle({lng: lngLat.lng, lat: lngLat.lat}, Number(document.getElementById('radiusInput').value || ${radius}));
      });
      marker.on('dragend', () => {
        const lngLat = marker.getLngLat();
        drawCircle({lng: lngLat.lng, lat: lngLat.lat}, Number(document.getElementById('radiusInput').value || ${radius}));
      });
      document.getElementById('radiusInput').addEventListener('input', (ev) => {
        const r = Number(ev.target.value || ${radius});
        const lngLat = marker.getLngLat();
        drawCircle({lng: lngLat.lng, lat: lngLat.lat}, r);
      }); 
      document.getElementById('done').addEventListener('click', () => {
        const lngLat = marker.getLngLat();
        marker.setLngLat(lngLat);
        drawCircle({lng: lngLat.lng, lat: lngLat.lat}, Number(document.getElementById('radiusInput').value || ${radius}));

        const r = Number(document.getElementById('radiusInput').value || ${radius});
        const payload = { lat: lngLat.lat, lng: lngLat.lng, radius: r };
        if(window.ReactNativeWebView && window.ReactNativeWebView.postMessage){
          window.ReactNativeWebView.postMessage(JSON.stringify(payload));
        } else {
          // debug log in iframe before post
          try { console.log('iframe posting payload to parent:', payload); } catch(e){}
          // When embedded in an iframe, post to the parent window
          try { window.parent && window.parent.postMessage && window.parent.postMessage(JSON.stringify(payload), '*'); } catch(e){}
        }
      });
    </script>
    </body>
    </html>`;
  };

  // For web we can use an iframe with the same HTML (srcdoc)
  const makeIframeHTML = (lat, lng, radius) => {
    return makeWebviewHTML(lat, lng, radius);
  };

  // Handler for messages from native WebView
  const handleWebViewMessage = (event) => {
    try {
      const data = JSON.parse(event.nativeEvent.data);
      if (data && data.lat && data.lng) {
        setbody({ lock_location_lat: data.lat ?? "13.736717", lock_location_lng: data.lng ?? "100.523186", lock_location_radius: data.radius ?? body.lock_location_radius });
      }
    } catch (e) {
      console.log('Invalid message from webview', e);
    }
  };

  function mapReward(rawRewards) {
    const rewards = JSON.parse(rawRewards);

    return rewards.map((reward) => {
      if (reward.shirt) {
        return {
          type: 'ไอเทม',
          shirt: reward.shirt,
        }
      }
      if (reward.diamond != undefined) {
        return {
          type: 'ไดมอนด์',
          diamond: !reward.diamond ? "0" : reward.diamond,
        }
      }

      return {
        type: 'โกลด์',
        coin: reward.coin,
      };
    });
  }

  const handleSubmit = async () => {
    let requestBody = { ...body, reward: dataReward };
    const eventId = route?.params?.id ?? null

    try {
      const response = await apiservice({
        path:
          "/event/" +
          (eventId ? "updateevent" : "create-event"),
        method: eventId ? "put" : "post",
        body: requestBody,
        token: token?.accessToken,
      });

      if (
        response.status == 200 &&
        eventId == undefined
      ) {
        const response1 = await apiservice({
          path: "/event/createbibrunning",
          method: "post",
          body: {
            event_id: response.data.data.id,
            last_number: 1,
            last_character: "A",
          },
          token: token?.accessToken,
        });
        if (response1.status == 200) {
          navigation.navigate("HomeEvent");
        }
      } else {
        if (response.status == 200 && eventId) {
          navigation.navigate("HomeEvent");
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (route?.params?.id) {
      requestEventDetail();
    }
  }, [focused]);

  async function requestEventDetail() {
    const response = await apiservice({
      path: '/event/getevent_select/' + route?.params?.id,
      token: token?.accessToken,
    });
    if (response.status === 200) {
      setbody({
        ...route.params,
        reward: response.data.reward,
        distances: response.data.distances,
        tag: response.data.tag,
        img_List: JSON.parse(route?.params?.img_List) ?? [],
        lock_location_lat: route?.params?.lock_location_lat === "null" ? null : route?.params?.lock_location_lat,
        lock_location_lng: route?.params?.lock_location_lng === "null" ? null : route?.params?.lock_location_lng,
        lock_location_radius: route?.params?.lock_location_radius === "null" ? null : route?.params?.lock_location_radius,
      });
      setDataReward(mapReward(route?.params?.reward));
    }
  }

  return (
    <View style={styles.container}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalresult}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalresult(!modalresult);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewinmodail}>
            <View
              style={{
                flexDirection: "row",
                width: width * 0.28,
                justifyContent: "space-between",
              }}
            >
              <Text
                style={[
                  styles.textname,
                  { alignSelf: "center" },
                  { marginLeft: 20 },
                ]}
              >
                เลือกไอเทม
              </Text>
              <TouchableOpacity
                onPress={() => setModalresult(!modalresult)}
                style={[
                  styles.tochup,
                  { backgroundColor: "#FCC81D" },
                  { marginLeft: 60 },
                ]}
              >
                <Text style={styles.textup}>ตกลง</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => setModalresult(!modalresult)}
                style={[styles.tochup, { marginLeft: 20 }]}
              >
                <Text style={styles.textup}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
            <View style={styles.line} />
            <View style={styles.liner}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  หัว
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i ? { shirt: { head: response } } : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0].shirt == {} ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:
                          dataReward?.[0].shirt != undefined &&
                          dataReward?.[0].shirt,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#F53C56" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  เสื้อ
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i ? { shirt: { SHirt: response } } : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0].shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:
                          dataReward != undefined &&
                          dataReward?.[0].shirt.SHirt,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#7764E4" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  กางเกง
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        length == i ? { shirt: { NET: response } } : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0].shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:
                          dataReward != undefined && dataReward?.[0].shirt.NET,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
            <View style={[styles.liner, { borderLeftColor: "#FEB969" }]}>
              <View style={styles.real}>
                <Text
                  style={[
                    styles.textname,
                    { alignSelf: "center" },
                    { marginLeft: 5 },
                  ]}
                >
                  รองเท้า
                </Text>
                <TouchableOpacity
                  onPress={async () => {
                    const response = await pickImage();
                    setDataReward(
                      dataReward.map((e, i) =>
                        index == i ? { shirt: { SHoot: response } } : e
                      )
                    );
                  }}
                  style={styles.ok}
                >
                  <Image
                    style={styles.imgko}
                    source={require("../../image/Group222.png")}
                  />
                  {dataReward != undefined && dataReward?.[0].shirt == null ? (
                    <Image
                      style={styles.imgko}
                      source={require("../../image/Group222.png")}
                    />
                  ) : (
                    <Image
                      style={{
                        width: 40,
                        height: 40,
                        alignSelf: "center",
                        zIndex: 99,
                      }}
                      source={{
                        uri:
                          dataReward != undefined &&
                          dataReward?.[0].shirt.SHoot,
                      }}
                    />
                  )}
                </TouchableOpacity>
              </View>
            </View>
            <View style={styles.line} />
          </View>
        </View>
      </Modal>

      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              EVENT{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>อีเวนท์ </Text>
              </Text>
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>ADD</Text>
              </Text>
            </Text>
            <View style={styles.viewtouch}>
              <TouchableOpacity
                onPress={handleSubmit}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>บันทึก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate("HomeEvent");
                }}
                style={styles.touchadd}
              >
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View
            style={{
              width: width * 0.82,
              borderWidth: 0.05,
              borderColor: "#00000010",
              backgroundColor: "#fff",
              shadowColor: "#000",
              shadowOffset: {
                width: 0,
                height: 2,
              },
              shadowOpacity: 0.25,
              shadowRadius: 3.84,
              elevation: 5,
              marginTop: 10,
            }}
          >
            <View style={styles.view}>
              <View style={styles.viewin}>
                <InputFree
                  value={body.titel}
                  onChangeText={(text) => setbody({ ...body, titel: text })}
                  name="ชื่อรายการ"
                  placeholder="กรอกชื่อรายการ"
                />
                <InputFree
                  value={body?.link_url}
                  onChangeText={(text) => setbody({ ...body, link_url: text })}
                  name="ลิงก์รายละเอียด"
                  placeholder="ลิงก์รายละเอียด"
                />
                <Text style={styles.textname}>รายละเอียด</Text>
                <TextInput
                  value={body.discription}
                  onChangeText={(text) =>
                    setbody({ ...body, discription: text })
                  }
                  multiline
                  style={styles.textinput}
                  placeholder="กรอกรายละเอียดเกี่ยวกับรายการนี้"
                />

                <View style={styles.kob}>
                  <Text style={styles.textname}>รูปหน้าปก</Text>
                  <View style={styles.style}>
                    {body.img_title == null ? (
                      <View style={styles.viewimg} />
                    ) : (
                      <Image
                        style={{ width: 120, height: 70, alignSelf: "center" }}
                        source={{
                          uri: body.img_title,
                        }}
                      />
                    )}
                    <View style={{ marginLeft: 20 }}>
                      <View style={{ flexDirection: "row" }}>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody({
                              ...body,
                              img_title: response,
                            });
                          }}
                          style={[
                            styles.tochup,
                            { backgroundColor: "#FCC81D" },
                          ]}
                        >
                          <Text style={styles.textup}>Upload</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await apiservice({
                              path: "/image/delete/" + body.img_title,
                              method: "delete",
                            });

                            setbody({ ...body, img_title: null });
                          }}
                          style={[styles.tochup, { marginLeft: 20 }]}
                        >
                          <Text style={styles.textup}>Reset</Text>
                        </TouchableOpacity>
                      </View>
                      <Text style={styles.textRe}>
                        Required image resolution 800x400, image size 10mb.
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.kob]}>
                  <Text style={styles.textname}>รูป MAP</Text>
                  <View style={styles.style}>
                    {body.img_Map == null ? (
                      <View style={{ flexDirection: "row" }}>
                        <View
                          style={[styles.viewimg, { alignSelf: "flex-end" }]}
                        />
                      </View>
                    ) : (
                      <View style={{ flexDirection: "row" }}>
                        <Image
                          style={{
                            width: 120,
                            height: 70,
                            alignSelf: "flex-end",
                          }}
                          source={{
                            uri: body.img_Map,
                          }}
                        />
                      </View>
                    )}

                    <View style={{ marginLeft: 20, alignSelf: "center" }}>
                      <View style={{ flexDirection: "row" }}>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody({ ...body, img_Map: response });
                          }}
                          style={[
                            styles.tochup,
                            { backgroundColor: "#FCC81D" },
                          ]}
                        >
                          <Text style={styles.textup}>Upload</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await apiservice({
                              path: "/image/delete/" + body.img_Map,
                              method: "delete",
                            });

                            setbody({ ...body, img_Map: null });
                          }}
                          style={[styles.tochup, { marginLeft: 20 }]}
                        >
                          <Text style={styles.textup}>Reset</Text>
                        </TouchableOpacity>
                      </View>
                      <Text style={[styles.textRe, { fontSize: 11 }]}>
                        Required image resolution 800x400, image size 10mb.
                      </Text>
                    </View>
                  </View>
                </View>
              </View>
              <View style={styles.viewin}>
                <View
                  style={[
                    styles.style,
                    { justifyContent: "space-between" },
                    { marginRight: 5 },
                  ]}
                >
                  <View>
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      สถานะ
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) =>
                        setbody({ ...body, status: text })
                      }
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.status}
                      items={items}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      ประเภท
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => setbody({ ...body, Type: text })}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.Type}
                      items={[
                        { label: "Event", value: "Event" },
                        { label: "Eventonroad", value: "Eventonroad" },
                      ]}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      ขายทุกเวลา
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => {
                        setbody({ ...body, is_end_expired: text })
                      }}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.is_end_expired?.toString()}
                      items={[
                        { label: "ใช่", value: "true" },
                        { label: "ไม่ใช่", value: "false" },
                      ]}
                    />
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      ใช้นาฬิกาได้
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => setbody({ ...body, is_strava_enable: text })}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.is_strava_enable?.toString()}
                      items={[
                        { label: "ใช่", value: "true" },
                        { label: "ไม่ใช่", value: "false" },
                      ]}
                    />

                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      เปิดใช้ gyroscope
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => setbody({ ...body, is_gyroscope_enabled: text })}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.is_gyroscope_enabled?.toString()}
                      items={[
                        { label: "ใช่", value: "true" },
                        { label: "ไม่ใช่", value: "false" },
                      ]}
                    />

                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      เปิดใช้ background location mode
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => setbody({ ...body, is_location_enabled: text })}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.is_location_enabled?.toString()}
                      items={[
                        { label: "ใช่", value: "true" },
                        { label: "ไม่ใช่", value: "false" },
                      ]}
                    />

                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      ล็อคโลเคชั่น
                    </Text>
                    <RNPickerSelect
                      placeholder={placeholder}
                      onValueChange={(text) => setbody({ ...body, is_location_locked: text })}
                      style={{
                        inputWeb: {
                          width: width * 0.18,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                        },
                      }}
                      value={body.is_location_locked?.toString()}
                      items={[
                        { label: "ใช่", value: "true" },
                        { label: "ไม่ใช่", value: "false" },
                      ]}
                    />

                    <View style={{ marginTop: 10 }}>
                      <Text style={[styles.textname, { marginBottom: 5, fontFamily: 'Prompt-Regular' }]}>ตำแหน่งล็อค (แผนที่)</Text>
                      <View style={{ flexDirection: 'row', gap: 8, alignItems: 'center' }}>
                        <Text style={{ fontSize: 12, fontFamily: 'Prompt-Regular' }}>{(formatCoord(body.lock_location_lat) && formatCoord(body.lock_location_lng)) ? `${formatCoord(body.lock_location_lat)}, ${formatCoord(body.lock_location_lng)}, รัศมี ${formatRadius(body.lock_location_radius)} ม` : 'ยังไม่ได้กำหนด'}</Text>
                      </View>
                    </View>

                    <TouchableOpacity onPress={openMapSelector} style={[styles.tochup, { marginLeft: 8, backgroundColor: '#FCC81D', marginTop: 18, alignItems: 'center', justifyContent: 'center' }]}>
                      <Text style={{ fontSize: 16, color: '#000', fontFamily: 'Prompt-Regular' }}>{'เลือกตำแหน่ง'}</Text>
                    </TouchableOpacity>
                  </View>
                  <View>
                    <Text style={[styles.textname, { marginBottom: 5 }]}>
                      แสดงผลวันที่
                    </Text>
                    <View style={{ gap: 10 }}>
                      <View style={{ flexDirection: "row", }}>
                        <TextInput
                          style={{
                            width: width * 0.18,
                            height: 30,
                            backgroundColor: "#fff",
                            borderWidth: 1,
                            borderColor: "#D9D9D9",
                            paddingLeft: 25,
                            borderRadius: 5,
                            color: "#777777",
                            fontFamily: "Prompt-Regular",
                            alignSelf: "center",
                          }}
                          type={true}
                          Locate={locate}
                          setLo={setLo}
                          setHandelCalendar={setHandelCalendar}
                          value={moment(body.startDate).format("DD/MM/YYYY")}
                          onChangeText={(text) => {
                            setbody({ ...body, startDate: text });
                          }}
                        />
                        <TouchableOpacity
                          onPress={() => {
                            setHandelCalendar((val) => !val);
                          }}
                          style={styles.botton3}
                        >
                          <FontAwesome5
                            name="calendar-alt"
                            size={18}
                            color="#AFAFAF"
                          />
                        </TouchableOpacity>
                      </View>
                      <View style={{ flexDirection: "row" }}>
                        <TextInput
                          style={{
                            width: width * 0.18,
                            height: 30,
                            backgroundColor: "#fff",
                            borderWidth: 1,
                            borderColor: "#D9D9D9",
                            paddingLeft: 25,
                            borderRadius: 5,
                            color: "#777777",
                            fontFamily: "Prompt-Regular",
                            alignSelf: "center",
                          }}
                          type={true}
                          Locate={locate1}
                          setLo={setLo1}
                          setHandelCalendar={setHandelCalendar1}
                          value={moment(body.expireDate).format("DD/MM/YYYY")}
                          onChangeText={(text) => {
                            setbody({ ...body, expireDate: text });
                          }}
                        />
                        <TouchableOpacity
                          onPress={() => {
                            setHandelCalendar1((val) => !val);
                          }}
                          style={styles.botton3}
                        >
                          <FontAwesome5
                            name="calendar-alt"
                            size={18}
                            color="#AFAFAF"
                          />
                        </TouchableOpacity>
                      </View>
                    </View>
                  </View>
                </View>

                <View>
                  <Text style={[styles.textname, { marginVertical: 10 }]}>
                    ของรางวัล
                  </Text>
                  <FlatList
                    data={body.reward}
                    extraData={[body]}
                    contentContainerStyle={{
                      gap: 10
                    }}
                    ListFooterComponent={
                      <TouchableOpacity
                        onPress={() => {
                          setbody((val) => ({
                            ...val,
                            reward: val.reward.concat({ type: "" }),
                          }));
                        }}
                        style={{
                          width: width * 0.395,
                          height: 30,
                          borderWidth: 1,
                          borderColor: "#ccc",
                          paddingLeft: 10,
                          borderRadius: 5,
                          color: "#777777",
                          fontFamily: "Prompt-Regular",
                          alignSelf: "center",
                          marginTop: 10,
                        }}
                      >
                        <Text style={styles.textup}>เพิ่ม</Text>
                      </TouchableOpacity>
                    }
                    renderItem={({ item, index }) => {
                      return (
                        <View style={{ backgroundColor: '#f4f4f4', borderRadius: 15, padding: 15 }}>
                          <Text style={styles.textname}>#{index + 1}</Text>
                          <TouchableOpacity
                            onPress={() => {
                              setbody((val) => ({
                                ...val,
                                reward: val.reward.filter((e, i) => i != index)
                              }));
                            }}
                            style={{
                              position: "absolute",
                              top: 5,
                              right: 5,
                            }}
                          >
                            <AntDesign
                              name="close"
                              size={14}
                              color="black"
                              style={{ marginLeft: -30, marginTop: 10 }}
                            />
                          </TouchableOpacity>
                          <RNPickerSelect
                            onValueChange={(text) => {
                              setbody((val) => ({
                                ...val,
                                reward: val.reward.map((itemss, indexss) => {
                                  if (indexss == index) {
                                    return { ...itemss, type: text };
                                  } else {
                                    return itemss;
                                  }
                                }),
                              }));
                            }}
                            placeholder={placeholder2}
                            value={item.type}
                            style={{
                              inputWeb: {
                                width: '100%',
                                height: 30,
                                borderWidth: 1,
                                borderColor: "#ccc",
                                paddingLeft: 10,
                                borderRadius: 5,
                                color: "#777777",
                                fontFamily: "Prompt-Regular",
                                alignSelf: "center",
                                marginTop: 10,
                              },
                            }}
                            items={items2}
                          />
                          {item.type == "โกลด์" && (
                            <View
                              style={{
                                width: '100%',
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: 10,
                              }}
                            >
                              <View style={{ width: '100%' }}>
                                <Text style={styles.textname}>จำนวน</Text>
                                <TextInput
                                  value={item.coin}
                                  onChangeText={(text) => {
                                    setbody((val) => ({
                                      ...val,
                                      reward: val.reward.map(
                                        (itemss, indexss) => {
                                          if (indexss == index) {
                                            return { ...itemss, coin: text };
                                          } else {
                                            return itemss;
                                          }
                                        }
                                      ),
                                    }));
                                    setDataReward(
                                      dataReward.map((e, i) => {
                                        return index == i
                                          ? { coin: text, type: "โกลด์" }
                                          : e;
                                      })
                                    );
                                  }}
                                  placeholder="กรอกเป็นตัวเลข"
                                  style={{
                                    width: '100%',
                                    height: 30,
                                    fontFamily: "Prompt-Regular",
                                    borderWidth: 1,
                                    borderColor: "#ccc",
                                    backgroundColor: '#fff',
                                    paddingLeft: 10,
                                    borderRadius: 5,
                                    marginTop: 10,
                                  }}
                                />
                              </View>
                              <View></View>
                            </View>
                          )}
                          {item.type == "ไดมอนด์" ? (
                            <View
                              style={{
                                width: '100%',
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: 10,
                              }}
                            >
                              <View style={{ width: '100%', }}>
                                <Text style={styles.textname}>จำนวน</Text>
                                <TextInput
                                  value={item.diamond}
                                  onChangeText={(text) => {
                                    setbody((val) => ({
                                      ...val,
                                      reward: val.reward.map(
                                        (itemss, indexss) => {
                                          if (indexss == index) {
                                            return { ...itemss, diamond: text };
                                          } else {
                                            return itemss;
                                          }
                                        }
                                      ),
                                    }));
                                    setDataReward(
                                      dataReward.map((e, i) =>
                                        index == i
                                          ? { diamond: text, type: "ไดมอนด์" }
                                          : e
                                      )
                                    );
                                  }}
                                  placeholder="กรอกเป็นตัวเลข"
                                  style={{
                                    width: '100%',
                                    height: 30,
                                    fontFamily: "Prompt-Regular",
                                    borderWidth: 1,
                                    borderColor: "#ccc",
                                    backgroundColor: '#fff',
                                    paddingLeft: 10,
                                    borderRadius: 5,
                                    marginTop: 10,
                                  }}
                                />
                              </View>
                            </View>
                          ) : (
                            <View />
                          )}
                        </View>
                      );
                    }}
                  />
                </View>

                <View style={styles.koblogo}>
                  <View style={styles.style}>
                    {body.Achievement == null ? (
                      <View style={styles.viewimglogo} />
                    ) : (
                      <Image
                        style={{ width: 70, height: 70, alignSelf: "center" }}
                        source={{
                          uri: body.Achievement,
                        }}
                      />
                    )}

                    <View style={{ marginLeft: 20 }}>
                      <View style={{ flexDirection: "row" }}>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody({
                              ...body,
                              Achievement: response,
                            });
                          }}
                          style={[
                            styles.tochup,
                            { backgroundColor: "#FCC81D" },
                          ]}
                        >
                          <Text style={styles.textup}>Upload</Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await apiservice({
                              path: "/image/delete/" + body.Achievement,
                              method: "delete",
                            });

                            setbody({ ...body, Achievement: null });
                          }}
                          style={[styles.tochup, { marginLeft: 20 }]}
                        >
                          <Text style={styles.textup}>Reset</Text>
                        </TouchableOpacity>
                        <Text style={[styles.textname, { marginLeft: 40 }]}>
                          รูปเหรียญรางวัล
                        </Text>
                      </View>
                      <Text style={styles.textRe}>
                        Required image resolution 90x90, image size 10mb.
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={[styles.kob1, { paddingVertical: 10 }]}>
                  <Text style={styles.textname}>รูปหน้าใน</Text>
                  <FlatList
                    data={body.img_List}
                    horizontal
                    scrollEnabled={false}
                    ListFooterComponent={
                      <View
                        style={{
                          flexDirection: "row",
                          alignSelf: "center",
                          marginTop: 10,
                        }}
                      >
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImageIn();
                            let arr = body.img_List;
                            let setArr = arr.concat({
                              ...response,
                              data: { imageRefId: response?.data },
                            });
                            setbody({ ...body, img_List: setArr });
                          }}
                          style={styles.viewimg}
                        >
                          <Image
                            style={{
                              width: 50,
                              height: 50,
                              position: "absolute",
                              alignSelf: "center",
                            }}
                            source={require("../../image/Group222.png")}
                          />
                        </TouchableOpacity>
                      </View>
                    }
                    renderItem={({ index, item }) => {
                      return (
                        <View>
                          <Image
                            style={{
                              width: 120,
                              height: 70,
                              alignSelf: "center",
                              marginTop: 10,
                              marginRight: 10,
                            }}
                            source={{
                              uri: item?.data?.imageRefId,
                            }}
                          />
                          <TouchableOpacity
                            onPress={async () => {
                              await apiservice({
                                path: "/image/delete/" + item,
                                method: "delete",
                              });
                              let Arr = body.img_List.filter((e) => e != item);
                              setbody({ ...body, img_List: Arr });
                            }}
                            style={{
                              position: "absolute",
                              alignSelf: "flex-end",
                            }}
                          >
                            <AntDesign
                              name="close"
                              size={14}
                              color="black"
                              style={{ marginLeft: -30, marginTop: 10 }}
                            />
                          </TouchableOpacity>
                        </View>
                      );
                    }}
                  />
                </View>
              </View>
            </View>

            <View style={{ width: width * 0.82, paddingHorizontal: 10 }}>
              <Text style={[styles.textname, { marginBottom: 5 }]}>แพ็คเกจ</Text>

              <FlatList
                data={body.distances}
                ListFooterComponent={
                  <TouchableOpacity
                    onPress={() => {
                      setbody((val) => ({
                        ...val,
                        distances: val.distances.concat({
                          title: "",
                          typeName: "",
                          couponPrice: "",
                          premiumPrice: "",
                          distance: "",
                          price: "",
                          cost: "",
                          img_pre: "",
                          img_basic: "",
                        }),
                      }));
                    }}
                    style={[styles.tochup, { marginBottom: 30 }]}
                  >
                    <Text style={styles.textup}>เพิ่ม</Text>
                  </TouchableOpacity>
                }
                renderItem={({ item, index }) => {

                  return (
                    <View
                      style={{
                        width: width * 0.8,
                        borderWidth: 0.5,
                        borderColor: "#44444460",
                        height: 280,
                        marginBottom: 30,
                        flexDirection: "row",
                        padding: 10,
                      }}
                    >
                      <View>
                        <Text style={styles.textname}>ชื่อแพ็คเกจ</Text>
                        <TextInput
                          value={item.title}
                          placeholder="ชื่อแพ็คเกจ"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, title: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                        <Text style={styles.textname}>ระยะทาง</Text>
                        <TextInput
                          value={item.distance}
                          placeholder="กรอกระยะทางเป็นตัวเลข"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, distance: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                        <Text style={styles.textname}>ราคา (คูปอง)</Text>
                        <TextInput
                          value={item.couponPrice}
                          placeholder="กรอกราคาคูปองเป็นตัวเลข"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, couponPrice: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                      </View>
                      <View style={{ marginLeft: 40 }}>
                        <Text style={styles.textname}>ประเภท</Text>
                        <TextInput
                          value={item.typeName}
                          placeholder="กรอกประเภท"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, typeName: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                        <Text style={styles.textname}>ค่าจัดส่ง</Text>
                        <TextInput
                          value={item.cost}
                          placeholder="กรอกจำนวนราคา"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, cost: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                        <Text style={styles.textname}>ราคา (Premium)</Text>
                        <TextInput
                          value={item.premiumPrice}
                          placeholder="กรอกราคาพรีเมียมเป็นตัวเลข"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, premiumPrice: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                        <Text style={styles.textname}>ราคา (ขายในแอพ)</Text>
                        <TextInput
                          value={item.price}
                          placeholder="กรอกราคาขายในแอพเป็นตัวเลข"
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return { ...items, price: text };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />

                        {body.Type == "Eventonroad" && (
                          <View>
                            <Text style={styles.textname}>เวลา</Text>
                            <TextInput
                              value={item.time}
                              placeholder="00:00"
                              onChangeText={(text) => {
                                setbody((val) => ({
                                  ...val,
                                  distance: val.distances.map(
                                    (items, indexs) => {
                                      if (index == indexs) {
                                        return { ...items, time: text };
                                      } else {
                                        return items;
                                      }
                                    }
                                  ),
                                }));
                              }}
                              style={{
                                width: width * 0.15,
                                height: 30,
                                fontFamily: "Prompt-Regular",
                                borderWidth: 1,
                                borderColor: "#ccc",
                                paddingLeft: 10,
                                borderRadius: 5,
                                marginTop: 10,
                              }}
                            />
                          </View>
                        )}
                      </View>
                      <View style={{ marginLeft: 40 }}>
                        <Text style={styles.textname}>รูป BIB PREMIUM</Text>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return {
                                    ...items,
                                    img_pre: response,
                                  };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: 160,
                            height: 90,
                            borderWidth: 0.5,
                            borderColor: "#DBDBDB",
                            borderRadius: 5,
                            justifyContent: "center",
                          }}
                        >
                          {item.img_pre == "" ? (
                            <Image
                              style={{
                                width: 50,
                                height: 50,
                                position: "absolute",
                                alignSelf: "center",
                              }}
                              source={require("../../image/Group222.png")}
                            />
                          ) : (
                            <Image
                              style={{
                                width: 161,
                                height: 91,
                                alignSelf: "center",
                              }}
                              source={{
                                uri: item.img_pre,
                              }}
                            />
                          )}
                        </TouchableOpacity>
                      </View>
                      <View style={{ marginLeft: 80 }}>
                        <Text style={styles.textname}>รูป BIB BASIC</Text>
                        <TouchableOpacity
                          onPress={async () => {
                            const response = await pickImage();
                            setbody((val) => ({
                              ...val,
                              distances: val.distances.map((items, indexs) => {
                                if (index == indexs) {
                                  return {
                                    ...items,
                                    img_basic: response,
                                  };
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: 160,
                            height: 90,
                            borderWidth: 0.5,
                            borderColor: "#DBDBDB",
                            borderRadius: 5,
                            justifyContent: "center",
                          }}
                        >
                          {!item.img_basic ? (
                            <Image
                              style={{
                                width: 50,
                                height: 50,
                                position: "absolute",
                                alignSelf: "center",
                              }}
                              source={require("../../image/Group222.png")}
                            />
                          ) : (
                            <Image
                              style={{
                                width: 161,
                                height: 91,
                                alignSelf: "center",
                              }}
                              source={{
                                uri: item.img_basic,
                              }}
                            />
                          )}
                        </TouchableOpacity>
                      </View>
                      <TouchableOpacity
                        onPress={() => {
                          setbody((val) => ({
                            ...val,
                            distances: val.distances.filter((e, i) => i != index),
                          }));
                        }}
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                        }}
                      >
                        <AntDesign
                          name="close"
                          size={14}
                          color="black"
                          style={{ marginLeft: -30, marginTop: 10 }}
                        />
                      </TouchableOpacity>
                    </View>
                  );
                }}
              />
            </View>

            <View style={{ width: width * 0.82, paddingHorizontal: 10 }}>
              <Text style={[styles.textname, { marginBottom: 5 }]}>รูปแบบ</Text>

              <FlatList
                data={body.tag}
                ListFooterComponent={
                  <TouchableOpacity
                    onPress={() => {
                      setbody((val) => ({
                        ...val,
                        tag: val.tag.concat(""),
                      }));
                    }}
                    style={[styles.tochup, { marginBottom: 30 }]}
                  >
                    <Text style={styles.textup}>เพิ่ม</Text>
                  </TouchableOpacity>
                }
                renderItem={({ item, index }) => {
                  return (
                    <View
                      style={{
                        width: width * 0.8,
                        borderWidth: 0.5,
                        borderColor: "#44444460",
                        height: 100,
                        marginBottom: 30,
                        flexDirection: "row",
                        padding: 10,
                      }}
                    >
                      <View>
                        <Text style={styles.textname}>ชื่อ</Text>
                        <TextInput
                          value={item}
                          placeholder="ชื่อ..."
                          onChangeText={(text) => {
                            setbody((val) => ({
                              ...val,
                              tag: val.tag.map((items, indexs) => {
                                if (index == indexs) {
                                  return text;
                                } else {
                                  return items;
                                }
                              }),
                            }));
                          }}
                          style={{
                            width: width * 0.15,
                            height: 30,
                            fontFamily: "Prompt-Regular",
                            borderWidth: 1,
                            borderColor: "#ccc",
                            paddingLeft: 10,
                            borderRadius: 5,
                            marginTop: 10,
                          }}
                        />
                      </View>

                      <TouchableOpacity
                        onPress={() => {
                          setbody((val) => ({
                            ...val,
                            tag: val.tag.filter((e, i) => i != index),
                          }));
                        }}
                        style={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                        }}
                      >
                        <AntDesign
                          name="close"
                          size={14}
                          color="black"
                          style={{ marginLeft: -30, marginTop: 10 }}
                        />
                      </TouchableOpacity>
                    </View>
                  );
                }}
              />
            </View>
          </View>
        </View>
      </ScrollView >
      {handelCalendar && (
        <View
          style={{
            width: width * 0.18,
            position: "absolute",

            top: height * 0.32,
            left: width * 0.8,
          }}
        >
          <Text
            style={{
              fontSize: 10,
              color: "#000",
              textAlign: "center",
              fontFamily: "Prompt-Regular",
            }}
          >
            <Calendar
              value={dateState}
              onChange={changeDate}
              onChangeText={(text) => {
                setbody({ ...body, startDate: text });
              }}
              onClickDay={(e) => {
                setbody({ ...body, startDate: e });
                setTimeout(() => {
                  setHandelCalendar((val) => !val);
                }, 500);
              }}
            />
          </Text>
        </View>
      )
      }
      {
        handelCalendar1 && (
          <View
            style={{
              width: width * 0.18,
              position: "absolute",
              zIndex: 99,
              top: height * 0.35,
              left: width * 0.8,
            }}
          >
            <Text
              style={{
                fontSize: 10,
                color: "#000",
                textAlign: "center",
                fontFamily: "Prompt-Regular",
              }}
            >
              <Calendar
                value={dateState1}
                onChange={changeDate1}
                onChangeText={(text) => {
                  setbody({ ...body, expireDate: text });
                }}
                onClickDay={(a) => {
                  setbody({ ...body, expireDate: a });
                  setTimeout(() => {
                    setHandelCalendar1((val) => !val);
                  }, 500);
                }}
              />
            </Text>
          </View>
        )
      }

      {/* Map selector modal */}
      {body?.is_location_locked && (
        <Modal
          animationType="slide"
          transparent={true}
          visible={showMapModal}
          onRequestClose={() => setShowMapModal(false)}
        >
          <View style={[styles.backmodal, { justifyContent: 'center', alignItems: 'center' }]}>
            <View style={{ width: width * 0.9, height: height * 0.75, backgroundColor: '#fff', borderRadius: 8, overflow: 'hidden' }}>
              <View style={{ flex: 1 }}>
                {Platform.OS === 'web' ? (
                  <View style={{ flex: 1 }}>
                    <iframe
                      title="map-selector"
                      srcDoc={makeIframeHTML(body.lock_location_lat ?? "13.736717", body.lock_location_lng ?? "100.523186", body.lock_location_radius ?? 100)}
                      style={{ width: '100%', height: '100%', border: 0 }}
                    />
                  </View>
                ) : (
                  <View style={{ flex: 1 }}>
                    {(() => {
                      try {
                        const { WebView } = require('react-native-webview');
                        return (
                          <WebView
                            originWhitelist={["*"]}
                            source={{ html: makeWebviewHTML(body.lock_location_lat ?? "13.736717", body.lock_location_lng ?? "100.523186", body.lock_location_radius ?? 100) }}
                            onMessage={handleWebViewMessage}
                          />
                        );
                      } catch (e) {
                        return <View style={{ padding: 20 }}><Text>WebView is not installed. Please add react-native-webview.</Text></View>;
                      }
                    })()}
                  </View>
                )}
              </View>
            </View>
          </View>
        </Modal>)}
    </View >
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textadd1: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "flex-end",
    gap: 10,
  },
  view: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 10,
    backgroundColor: "#ffffff",
  },
  koblogo: {
    width: width * 0.395,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob: {
    width: width * 0.395,
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  kob1: {
    width: width * 0.395,

    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 120,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  viewimg1: {
    width: 60,
    height: 100,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  viewimgbib: {
    width: 160,
    height: 90,
    justifyContent: "center",
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },

  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.19,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.395,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.25,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
  },
  textinput: {
    width: width * 0.395,
    height: 70,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewmain: {
    width: width * 0.395,
    height: 75,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingHorizontal: 10,
    borderRadius: 5,
    marginBottom: 10,
    marginTop: 10,
    justifyContent: "space-between",
    flexDirection: "row",
  },
  mainin: {
    width: width * 0.18,
    alignSelf: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  botton: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
  },
  inputimni: {
    width: width * 0.12,
    height: 38,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  logo: {
    width: width * 0.245,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "row",
  },
  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  touchsmall: {
    backgroundColor: "#FCC81D",
    width: 60,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textsmall: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textmini: {
    fontSize: 9,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  backmodal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewinmodail: {
    width: width * 0.5,
    alignSelf: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 30,
  },
  imgko: {
    width: 25,
    height: 25,
    position: "absolute",
    alignSelf: "center",
  },
  line: {
    width: width * 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#44444440",
    marginTop: 10,
  },
  liner: {
    flexDirection: "row",
    width: width * 0.48,
    justifyContent: "space-between",
    height: 40,
    borderLeftWidth: 1,
    borderLeftColor: "#2DCE98",
    marginTop: 10,
    alignSelf: "center",
  },
  ok: {
    width: 40,
    height: 40,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
  real: {
    width: width * 0.15,
    justifyContent: "space-between",
    alignSelf: "center",
    flexDirection: "row",
  },
  botton3: {
    alignSelf: "center",
    marginLeft: -25,
  },
});
